import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('organizations_quick_pricer_setting', {
  include_rebate: '',
  organization_id: '',
})
